import React, { useEffect } from 'react';

function NotFound() {

  useEffect(() => {
    const navbar = document.getElementById('navbar');
    if (navbar) {
      navbar.classList.add('page');
    }
  }, []);

    return (
      <div className='container d-flex justify-content-center'>
        <h2>Oups page introuvable ! </h2>
      </div>
    )
}

export default NotFound;